import { Provider } from '@angular/core';
import { CreateStepUseCase } from '@app/application/use-cases/task-template/create-step.use-case';
import { CreateTaskTemplateUseCase } from '@app/application/use-cases/task-template/create-task-template.use-case';
import { DeleteStepUseCase } from '@app/application/use-cases/task-template/delete-step.use-case';
import { DeleteTaskTemplateUseCase } from '@app/application/use-cases/task-template/delete-task-template.use-case';
import { GetAddedTaskTemplateItemsUseCase } from '@app/application/use-cases/task-template/get-added-task-template-items.use-case';
import { GetAvailableTaskTemplateItemsUseCase } from '@app/application/use-cases/task-template/get-available-task-template-items.use-case';
import { GetListUseCase } from '@app/application/use-cases/task-template/get-list-task-templates.use-case';
import { GetSubTasksByTaskTemplateIdUseCase } from '@app/application/use-cases/task-template/get-sub-tasks-by-task-template-id.use-case';
import { GetTaskTemplateDetailsUseCase } from '@app/application/use-cases/task-template/get-task-template-details.use-case';
import { UpdateStepUseCase } from '@app/application/use-cases/task-template/update-step.use-case';
import { UpdateTaskTemplateStatusUseCase } from '@app/application/use-cases/task-template/update-task-template-status.use-case';
import { UpdateTaskTemplateUseCase } from '@app/application/use-cases/task-template/update-task-template.use-case';
import { TaskTemplateRepository } from '@app/domain/repositories/task-template.repository';
import { TaskTemplateRepositoryImpl } from '../repositories/task-template.repository.impl';

export const TASK_TEMPLATE_PROVIDERS: Provider[] = [
  { provide: TaskTemplateRepository, useClass: TaskTemplateRepositoryImpl },
  {
    provide: GetListUseCase,
    useFactory: (taskTemplateRepo: TaskTemplateRepository) =>
      new GetListUseCase(taskTemplateRepo),
    deps: [TaskTemplateRepository],
  },
  {
    provide: GetTaskTemplateDetailsUseCase,
    useFactory: (taskTemplateRepo: TaskTemplateRepository) =>
      new GetTaskTemplateDetailsUseCase(taskTemplateRepo),
    deps: [TaskTemplateRepository],
  },
  {
    provide: CreateTaskTemplateUseCase,
    useFactory: (taskTemplateRepo: TaskTemplateRepository) =>
      new CreateTaskTemplateUseCase(taskTemplateRepo),
    deps: [TaskTemplateRepository],
  },
  {
    provide: UpdateTaskTemplateUseCase,
    useFactory: (taskTemplateRepo: TaskTemplateRepository) =>
      new UpdateTaskTemplateUseCase(taskTemplateRepo),
    deps: [TaskTemplateRepository],
  },
  {
    provide: GetAvailableTaskTemplateItemsUseCase,
    useFactory: (taskTemplateRepo: TaskTemplateRepository) =>
      new GetAvailableTaskTemplateItemsUseCase(taskTemplateRepo),
    deps: [TaskTemplateRepository],
  },
  {
    provide: GetAddedTaskTemplateItemsUseCase,
    useFactory: (taskTemplateRepo: TaskTemplateRepository) =>
      new GetAddedTaskTemplateItemsUseCase(taskTemplateRepo),
    deps: [TaskTemplateRepository],
  },
  {
    provide: DeleteTaskTemplateUseCase,
    useFactory: (taskTemplateRepo: TaskTemplateRepository) =>
      new DeleteTaskTemplateUseCase(taskTemplateRepo),
    deps: [TaskTemplateRepository],
  },
  {
    provide: GetSubTasksByTaskTemplateIdUseCase,
    useFactory: (taskTemplateRepo: TaskTemplateRepository) =>
      new GetSubTasksByTaskTemplateIdUseCase(taskTemplateRepo),
    deps: [TaskTemplateRepository],
  },
  {
    provide: CreateStepUseCase,
    useFactory: (taskTemplateRepo: TaskTemplateRepository) =>
      new CreateStepUseCase(taskTemplateRepo),
    deps: [TaskTemplateRepository],
  },
  {
    provide: UpdateStepUseCase,
    useFactory: (taskTemplateRepo: TaskTemplateRepository) =>
      new UpdateStepUseCase(taskTemplateRepo),
    deps: [TaskTemplateRepository],
  },
  {
    provide: DeleteStepUseCase,
    useFactory: (taskTemplateRepo: TaskTemplateRepository) =>
      new DeleteStepUseCase(taskTemplateRepo),
    deps: [TaskTemplateRepository],
  },
  {
    provide: UpdateTaskTemplateStatusUseCase,
    useFactory: (taskTemplateRepo: TaskTemplateRepository) =>
      new UpdateTaskTemplateStatusUseCase(taskTemplateRepo),
    deps: [TaskTemplateRepository],
  },
];
